import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSailboat = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 142,
	height: 114,
	fill: "none",
	viewBox: "0 0 142 114",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M10 111c-2-.7-1.4-3.6.7-3.6h120.5c2.2 0 2.7 3 .7 3.6l-7.9 3-.6.1h-105l-.6-.1-7.8-3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F07A7A",
			d: "M94.4 44.4c12.3 19.7 20.7 59.2 20.7 59.2s-17.7-5-29-3.6c-9.3 1.2-23.6 5.6-23.6 5.6s1.2-25.8 0-42.3c-1.7-25-11-63.3-11-63.3s30.1 24 43 44.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M40.3 72.5a560 560 0 0 1-13 33s9.5-3.1 16.3-3.1c6.7 0 15.3 3.2 15.3 3.2s0-20.2-1.4-33c-1.7-14.4-7-36.3-7-36.3S45 58.6 40.3 72.5Z"
		})
	]
});
export default SvgSailboat;
